import {Box, ExpandableSection, Header, Grid, Link} from '@amzn/awsui-components-react';
import React, {useEffect, useState} from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import {getIapPageUrl, getRablUrl} from '../../backend/internalUrls';
import {AvailabilityConsumer} from '../../backend/model';

interface AcSummaryPanelProps extends RouteComponentProps {
    ac: AvailabilityConsumer;
    iapId?: string;
    fnsku?: string;
    programDescription?: string;
}

const AcSummaryPanel: React.FC<AcSummaryPanelProps> = (props) => {
    const [ac, setAc] = useState(props.ac)
    const [iapId, setIapId] = useState(props.iapId)
    const [fnsku, setFnsku] = useState(props.fnsku)
    const [programDescription, setProgramDescription] = useState(props.programDescription)

    useEffect(() => {
            setAc(props.ac)
            setIapId(props.iapId)
            setFnsku(props.fnsku)
            setProgramDescription(props.programDescription)
            ReactTooltip.rebuild()
        }, [props]
    )

    const summary = (
        <Grid
            disableGutters
            gridDefinition={[
                {colspan:{default:6, xxs:2}},
                {colspan:{default:6, xxs:5}},
                {colspan:{default:6, xxs:2}},
                {colspan:{default:6, xxs:3}},
                {colspan:{default:6, xxs:2}},
                {colspan:{default:6, xxs:5}},
                {colspan:{default:6, xxs:2}},
                {colspan:{default:6, xxs:3}},
                {colspan:{default:6, xxs:2}},
                {colspan:{default:6, xxs:5}},
                {colspan:{default:6, xxs:2}},
                {colspan:{default:6, xxs:3}},
            ]}>
                <Box variant="p" >AC: </Box>
                <Box variant="p" id='asp-acId'>{ac.id}</Box>
                <Box variant="p" >IAP: </Box>
                <Box variant="p" id='asp-iapId'>
                    {(
                        iapId &&
                        <Link id='asp-iapLink' href={getIapPageUrl(iapId, fnsku)}>{iapId}</Link>
                    )
                    || 'none'}
                </Box>
                <Box variant="p">Marketplace: </Box>
                <Box variant="p" id='asp-marketplaceId'>{ac.key.marketplaceId}</Box>
                <Box variant="p">Program: </Box>
                <Box variant="p" id='asp-programId'>
                    {ac.key.fulfillmentProgramId ? (
                        <span data-tip={programDescription || 'Program does not exist in PJS.'} data-for="program-tooltip" style={{textDecoration: 'underline', cursor: 'help'}}>
                            {ac.key.fulfillmentProgramId}
                        </span>
                    ) : 'none'}
                </Box>
                <Box variant="p">Merchant: </Box>
                <Box variant="p" id='asp-merchantCustomerId'>{ac.key.merchantCustomerId}</Box>
                <Box variant="p">Region: </Box>
                <Box variant="p" id='asp-regionId'>
                    {ac.key.fulfillmentRegionId ? (
                        <Link href={getRablUrl(ac.key.fulfillmentRegionId)} external>
                                {ac.key.fulfillmentRegionId}
                        </Link>
                    ) : 'none'}
                </Box>
        </Grid>
    )

    return (
        <ExpandableSection
            id='acSummaryPanel'
            variant='container'
            header={<Header variant="h2">Summary</Header>}
            defaultExpanded>
            {summary}
            <ReactTooltip id="program-tooltip" effect="solid"/>
        </ExpandableSection>
    )
}

export default withRouter(AcSummaryPanel)
